/**
 * vo-manifest.ts — GENERATED by scripts/generate-vo.py. Do not edit by hand.
 *
 * Measured duration, in ms, of each splash voiceover clip.
 *
 * The splash paces each caption's typing from these numbers so the text
 * finishes exactly when the voice does. Without them the captions run at a
 * fixed 44 ms/char — about 227 wpm — while a grim read lands nearer 130, so
 * every line finished typing early and the voice talked over the next one.
 *
 * An EMPTY array is the off switch: no clips, no voiceover, and the splash
 * falls back to its own typing rate. There is no separate flag.
 */
export const VO_DURATIONS_MS: readonly number[] = [
  5120,
  7053,
  3605,
  6165,
  1463,
  7053,
  6243,
  2900,
  8020
]
